import { defineInputRule } from "prosekit/extensions/input-rule";
import { InputRule } from "prosekit/pm/inputrules";

// Regex pattern for markdown links: [text](url)
// Uses balanced parentheses matching to handle URLs with parens like .../P10_QE(2026)000877_EN.pdf
const MARKDOWN_LINK_PATTERN =
  /\[([^\]\n]+)\]\(((https?|ftps?|file):\/\/[^()\n]*(?:\([^()\n]*\)[^()\n]*)*|(mailto|tel):[^()\n]*(?:\([^()\n]*\)[^()\n]*)*)\)$/;

/**
 * Apply link marks when a markdown link is typed.
 * Example: [foo](https://bar.com) -> converts to a link on typing the closing parenthesis
 */
export function defineMarkdownLinkInputRule() {
  return defineInputRule(
    new InputRule(MARKDOWN_LINK_PATTERN, (state, match, from) => {
      const [fullMatch, text, url] = match;
      if (!text || !url) return null;

      // Create a link mark with the URL
      const mark = state.schema.marks.link.create({ href: url });

      // Replace the markdown syntax with just the text, and apply the link mark
      return state.tr
        .replaceWith(from, from + fullMatch.length, state.schema.text(text))
        .addMark(from, from + text.length, mark);
    }),
  );
}
